import React from "react";
import "../styles/Header.css";
import star from "../assets/staricon.png";

function Header() {
  return (
    <header className="header">
      <div className="name">
        <img src={star} alt="star icon" className="icon" />
        <h1 className="logo">Christina</h1>
      </div>
      <nav>
        <ul className="nav-links">
          <li>
            <a href="#intro" className="nav-option">
              About
            </a>
          </li>
          <li>
            <a href="#projects" className="nav-option">
              Projects
            </a>
          </li>
          <li>
            <a href="#work" className="nav-option">
              Work
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
